import React, { useRef } from 'react';
import ProveranceRisk from '../widgets/proverance-risk';
import SupplyChainRisk from '../widgets/supply-chain-risk';
import useFetchHelper from '../../../../helpers/useFetchHelper';

const RiskOverview = ({
  provenanceRisk,
  supplyChainRisk,
  loading = true,
  selectedProject,
  assessed,
}) => {
  const ref = useRef();

  const { canFetch } = useFetchHelper({ ref });

  return (
    <section className="no-wrap-section overflow-section" ref={ref}>
      <ProveranceRisk
        data={provenanceRisk}
        canFetch={canFetch}
        loadingData={loading}
      />
      <SupplyChainRisk
        data={supplyChainRisk}
        assessed={assessed}
        selectedProject={selectedProject}
        loadingData={loading}
        canFetch={canFetch}
      />
    </section>
  );
};

export default RiskOverview;
